export default __webpack_public_path__ + "static/media/Figtree-Regular.eb52c457.ttf";